<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Import Branch Stock</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete autocomplete="off" dense outlined v-model="selectedCustomer" :items="customers"
              label="Select Customer" item-text="Name" item-value="id" :search-input.sync="searchCustomers"
              @change="getBranches(selectedCustomer)"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="4">
            <v-autocomplete name="checkStockStore" dense outlined v-model="queryStore" :items="stores"
              label="Select Branch" item-text="Name" item-value="id"></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4">
            <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
          </v-col>

          <v-col cols="4">
            <v-file-input name="productExcelFile" v-model="excelFile" label="Browse Excel Sheet" outlined
              dense></v-file-input>
          </v-col>

          <v-col cols="12">
            <v-btn color="primary" @click="uploadExcel" :loading="$store.state.btnLoader">
              <v-icon left>mdi-upload</v-icon>Upload Stock
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({
    search: "",
    searchCustomers: null,
    selectedCustomer: {},
    customers: [],
    queryStore: null,
    stores: [],
    loader: false,
    excelFile: null,
    date: null
  }),
  watch: {
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    queryCustomers(searchText) {
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBranches(id) {
      const self = this;
      var url = `/stores/customers/${id}`;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    uploadExcel() {
      var store_id = this.queryStore;
      var subscriber_id = localStorage.getItem("subscriber_id");

      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show(
          "Please select date",
          "red"
        );
        return;
      }

      if (store_id == null || store_id == undefined) {
        this.$refs.snackbar.show(
          "Please select branch",
          "red"
        );
        return;
      }

      var date = this.date;

      const data = new FormData();
      data.append("documentData", this.excelFile);
      data.append("store_id", parseInt(store_id));
      data.append("subscriber_id", parseInt(subscriber_id));
      data.append("date", date);
      this.$store.commit("btnLoader", true);
      const url = "/import-branch-stock";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show(
              "Stock imported successfully",
              "green"
            );
            self.$store.commit("btnLoader", false);
            self.excelFile = null;
          } else {
            self.$store.commit("btnLoader", false);
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
      // end
    },
  },
  created() {

  },
};
</script>